import { render, staticRenderFns } from "./translationsMeal.vue?vue&type=template&id=3622de22&"
import script from "./translationsMeal.vue?vue&type=script&lang=js&"
export * from "./translationsMeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports